export var HeadingRegularVariants;
(function (HeadingRegularVariants) {
    HeadingRegularVariants["first"] = "headingRegular1";
    HeadingRegularVariants["second"] = "headingRegular2";
    HeadingRegularVariants["third"] = "headingRegular3";
    HeadingRegularVariants["fourth"] = "headingRegular4";
    HeadingRegularVariants["fifth"] = "headingRegular5";
    HeadingRegularVariants["sixth"] = "headingRegular6";
    HeadingRegularVariants["second_and_first"] = "second_and_first";
})(HeadingRegularVariants || (HeadingRegularVariants = {}));
export var HeadingDisplayVariants;
(function (HeadingDisplayVariants) {
    HeadingDisplayVariants["first"] = "headingDisplay1";
    HeadingDisplayVariants["second"] = "headingDisplay2";
    HeadingDisplayVariants["third"] = "headingDisplay3";
    HeadingDisplayVariants["fourth"] = "headingDisplay4";
    HeadingDisplayVariants["fifth"] = "headingDisplay5";
    HeadingDisplayVariants["sixth"] = "headingDisplay6";
})(HeadingDisplayVariants || (HeadingDisplayVariants = {}));
export var TextVariants;
(function (TextVariants) {
    TextVariants["technicalParagraphSmall"] = "technicalParagraphSmall";
    TextVariants["technicalParagraphLarge"] = "technicalParagraphLarge";
    TextVariants["editorialParagraphSmall"] = "editorialParagraphSmall";
    TextVariants["editorialParagraphLarge"] = "editorialParagraphLarge";
    TextVariants["label1"] = "label1";
    TextVariants["label2"] = "label2";
    TextVariants["label3"] = "label3";
    TextVariants["label1Bold"] = "label1Bold";
    TextVariants["label2Bold"] = "label2Bold";
    TextVariants["label3Bold"] = "label3Bold";
    TextVariants["quote"] = "quote";
    TextVariants["deck"] = "deck";
})(TextVariants || (TextVariants = {}));
// these need a bit of a cleanup to be more dx friendly -
export var LinkVariants;
(function (LinkVariants) {
    LinkVariants["standard"] = "standard";
    LinkVariants["standardNoUnderline"] = "standardNoUnderline";
    LinkVariants["navBar"] = "navBar";
    LinkVariants["link_h6"] = "link_h6";
    LinkVariants["desktopTray"] = "desktopTray";
    LinkVariants["nonUnderlined"] = "nonUnderlined";
    LinkVariants["footer"] = "footer";
    LinkVariants["copyright"] = "copyright";
    LinkVariants["breadcrumb"] = "breadcrumb";
    LinkVariants["card"] = "card";
    LinkVariants["primaryButton"] = "primaryButton";
})(LinkVariants || (LinkVariants = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight["textRegular"] = "textRegular";
    FontWeight["textBold"] = "textBold";
    FontWeight["displayRegular"] = "displayRegular";
    FontWeight["displayBold"] = "displayBold";
})(FontWeight || (FontWeight = {}));
export var LineHeights;
(function (LineHeights) {
    LineHeights["editorial"] = "editorial";
    LineHeights["heading"] = "heading";
    LineHeights["label"] = "label";
    LineHeights["largeHeadings"] = "largeHeadings";
})(LineHeights || (LineHeights = {}));
export var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["primary"] = "primary";
    ButtonVariants["secondary"] = "secondary";
    ButtonVariants["tertiary"] = "tertiary";
    ButtonVariants["destructive"] = "destructive";
    ButtonVariants["hollowDark"] = "hollowDark";
    ButtonVariants["hollowLight"] = "hollowLight";
    ButtonVariants["outlineDark"] = "outlineDark";
    ButtonVariants["outlineLight"] = "outlineLight";
    ButtonVariants["white"] = "white";
    ButtonVariants["actionableTagPrimary"] = "actionableTagPrimary";
    ButtonVariants["actionableTagSecondary"] = "actionableTagSecondary";
    ButtonVariants["quantity"] = "quantity";
    ButtonVariants["accessible"] = "accessible";
})(ButtonVariants || (ButtonVariants = {}));
export var Colors;
(function (Colors) {
    Colors["black"] = "black";
    Colors["white"] = "white";
    Colors["grey"] = "grey";
    Colors["green"] = "green";
    Colors["yellow"] = "yellow";
    Colors["red"] = "red";
    Colors["blue"] = "blue";
    Colors["background"] = "background";
    Colors["softBackground"] = "softBackground";
    Colors["primary"] = "primary";
    Colors["secondary"] = "secondary";
    Colors["accent"] = "accent";
    Colors["heading"] = "heading";
    Colors["text"] = "text";
    Colors["muted"] = "muted";
    Colors["stroke"] = "stroke";
})(Colors || (Colors = {}));
export var Fonts;
(function (Fonts) {
    Fonts["text"] = "text";
    Fonts["display"] = "display";
})(Fonts || (Fonts = {}));
export var Shadows;
(function (Shadows) {
    Shadows["small"] = "small";
    Shadows["large"] = "large";
})(Shadows || (Shadows = {}));
export var FormVariants;
(function (FormVariants) {
    FormVariants["input"] = "input";
    FormVariants["select"] = "select";
    FormVariants["selectOutlineDark"] = "selectOutlineDark";
    FormVariants["textarea"] = "textarea";
    FormVariants["label"] = "label";
    FormVariants["radio"] = "radio";
    FormVariants["checkbox"] = "checkbox";
    FormVariants["search"] = "search";
})(FormVariants || (FormVariants = {}));
export var Variants;
(function (Variants) {
    Variants["notification"] = "alerts";
    Variants["radioCard"] = "radioCard";
    Variants["box"] = "box";
})(Variants || (Variants = {}));
export var NotificationVariants;
(function (NotificationVariants) {
    NotificationVariants["information"] = "information";
    NotificationVariants["warning"] = "warning";
    NotificationVariants["success"] = "success";
    NotificationVariants["icon"] = "icon";
})(NotificationVariants || (NotificationVariants = {}));
export var BoxVariants;
(function (BoxVariants) {
    BoxVariants["grow"] = "grow";
})(BoxVariants || (BoxVariants = {}));
export var InputTypes;
(function (InputTypes) {
    InputTypes["text"] = "text";
    InputTypes["email"] = "email";
    InputTypes["password"] = "password";
})(InputTypes || (InputTypes = {}));
export var LabelVariants;
(function (LabelVariants) {
    LabelVariants["input"] = "input";
    LabelVariants["nav"] = "nav";
})(LabelVariants || (LabelVariants = {}));
export var InputVariants;
(function (InputVariants) {
    InputVariants["primary"] = "primary";
    InputVariants["secondary"] = "secondary";
    InputVariants["text"] = "text";
})(InputVariants || (InputVariants = {}));
export var zIndices;
(function (zIndices) {
    zIndices["overlay"] = "overlay";
    zIndices["notification"] = "notification";
    zIndices["modal"] = "modal";
    zIndices["megaMenu"] = "megaMenu";
    zIndices["stickyBars"] = "stickyBars";
    zIndices["stickyBarOverlay"] = "stickyBarOverlay";
    zIndices["inPage"] = "inPage";
    zIndices["page"] = "page";
    zIndices["search"] = "search";
    zIndices["trayMenu"] = "trayMenu";
})(zIndices || (zIndices = {}));
export var radii;
(function (radii) {
    radii["clickable"] = "clickable";
    radii["pills"] = "pills";
})(radii || (radii = {}));
export var ImageVariants;
(function (ImageVariants) {
    ImageVariants["contain"] = "fullBleedContain";
    ImageVariants["cover"] = "fullBleedCover";
    ImageVariants["ratio_3x4"] = "ratio_3x4";
    ImageVariants["ratio_4x3"] = "ratio_4x3";
    ImageVariants["ratio_16x9"] = "ratio_16x9";
    ImageVariants["ratio_1x1"] = "ratio_1x1";
    ImageVariants["ratio_21x9"] = "ratio_21x9";
    ImageVariants["ratio_none"] = "none";
    ImageVariants["ratio_1x1_and_21x9"] = "ratio_1x1_and_21x9";
})(ImageVariants || (ImageVariants = {}));
export var ContentColorModeEnums;
(function (ContentColorModeEnums) {
    ContentColorModeEnums["light"] = "light";
    ContentColorModeEnums["mid"] = "mid";
    ContentColorModeEnums["dark"] = "dark";
})(ContentColorModeEnums || (ContentColorModeEnums = {}));
export var ContentColorModeVariants;
(function (ContentColorModeVariants) {
    // bgCommercialDark =  "contentBackgroundCommercialDark",
    // bgCommercialLight =  "contentBackgroundCommercialLight",
    // bgEditorialDark =  "contentBackgroundEditorialDark",
    // bgEditorialLight  =  "contentBackgroundEditorialLight",
    ContentColorModeVariants["bgDark"] = "contentBGDark";
    ContentColorModeVariants["bgMid"] = "contentBGMid";
    ContentColorModeVariants["bgLight"] = "contentBGLight";
    ContentColorModeVariants["borderDark"] = "contentborderDark";
    ContentColorModeVariants["borderMid"] = "contentborderMid";
    ContentColorModeVariants["borderLight"] = "contentborderLight";
    ContentColorModeVariants["textSupportingDark"] = "contentTextSupportingDark";
    ContentColorModeVariants["textTitleDark"] = "contentTextTitleDark";
    ContentColorModeVariants["textLinkDark"] = "contentTextLinkDark";
    ContentColorModeVariants["textLinkLight"] = "contentTextLinkLight";
    ContentColorModeVariants["textTitleLight"] = "contentTextTitleLight";
    ContentColorModeVariants["textSupportingLight"] = "contentTextSupportingLight";
    ContentColorModeVariants["textLinkMid"] = "contentTextLinkMid";
    ContentColorModeVariants["textTitleMid"] = "contentTextTitleMid";
    ContentColorModeVariants["textSupportingMid"] = "contentTextSupportingMid";
})(ContentColorModeVariants || (ContentColorModeVariants = {}));
//# sourceMappingURL=enums.js.map